import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQueryField]'})
export class QueryFieldDirective {
  constructor(public template: TemplateRef<any>) {}
}
